import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Schema from './Schema';
export default function ObjectProperties({ schema, level, onAdd, onChange, }) {
    if (!schema.properties)
        return null;
    function handlePropertyChange(key, propertySchema) {
        onChange({
            ...structuredClone(schema),
            properties: {
                ...structuredClone(schema.properties),
                [key]: propertySchema,
            },
        });
    }
    function handlePropertyKeyChange(oldKey, newKey) {
        const properties = {};
        for (const [key, value] of Object.entries(schema.properties)) {
            if (key == oldKey) {
                properties[newKey] = value;
            }
            else {
                properties[key] = value;
            }
        }
        const newValue = {
            ...structuredClone(schema),
            properties: properties,
        };
        if (newValue.required) {
            newValue.required = newValue.required.map((pk) => pk === oldKey ? newKey : pk);
        }
        onChange(newValue);
    }
    function handlePropertyDelete(key) {
        const properties = structuredClone(schema.properties);
        if (properties === null || properties === void 0 ? void 0 : properties[key]) {
            delete properties[key];
        }
        const newValue = {
            ...structuredClone(schema),
            properties,
        };
        if (newValue.required) {
            newValue.required = newValue.required.filter((pk) => pk !== key);
        }
        onChange(newValue);
    }
    function handlePropertyRequiredChange(key, required) {
        var _a, _b;
        if (required) {
            onChange({
                ...structuredClone(schema),
                required: [...((_a = schema.required) !== null && _a !== void 0 ? _a : []), key],
            });
        }
        else {
            onChange({
                ...structuredClone(schema),
                required: ((_b = schema.required) !== null && _b !== void 0 ? _b : []).filter((pk) => pk !== key),
            });
        }
    }
    const isPropertyRequiredOn = (key) => {
        return Array.isArray(schema.required) && schema.required.includes(key);
    };
    const propertyNames = Object.keys(schema.properties);
    const propertyList = Object.entries(schema.properties).map((prop, idx) => {
        const name = prop[0];
        const value = prop[1];
        return (_jsx(Schema, { name: name, schema: value, isRequired: isPropertyRequiredOn(name), onRequiredChange: (value) => handlePropertyRequiredChange(name, value), level: level, onChange: (schema) => handlePropertyChange(name, schema), onNameChange: (newName) => handlePropertyKeyChange(name, newName), onDelete: () => handlePropertyDelete(name), onAdd: onAdd, deprecatedNames: propertyNames.filter((n) => n !== name) }, idx));
    });
    return _jsxs(_Fragment, { children: [propertyList, " "] });
}
//# sourceMappingURL=ObjectProperties.js.map